import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 103.45 103.44"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M103.45 4.78 98.67 0 51.72 46.94 4.78 0 0 4.78l46.94 46.94L0 98.66l4.78 4.78L51.72 56.5l46.95 46.94 4.78-4.78L56.5 51.72l46.95-46.94Z",
  style: {"fill":"#181716"}
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }